import React, {useEffect, useState} from 'react';
import customer from "../../network/services/customer";
import {getUserPhoneNumber, getUserType} from "../../helpers/authenticator";
import DeliveryItem from "../../components/dashboard/DeliveryItem";
import general_helper from "../../helpers/general_helper";
import rider from "../../network/services/rider";
import Loader from "react-loaders";

const DeliveryHistory = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [deliveries, setDeliveries] = useState([]);


    useEffect(() => {
        fetch()
    }, []);


    fetch = () => {
        if (getUserType() === general_helper.deliveryType.rider) {
            rider.getRiderDeliveryHistory(getUserPhoneNumber()).then(response => {
                    setDeliveries([...deliveries, ...response.data.data]);
                    setIsLoading(false);
                }
            ).catch(error => {
            });
        } else {
            customer.getDeliveryHistory(getUserPhoneNumber()).then(response => {
                    setDeliveries([...deliveries, ...response.data.data]);
                    setIsLoading(false);
                }
            ).catch(error => {
            });
        }
    };


    return (
        <>
            <div style={{minHeight: 600, marginTop: 150}}>
                <div className="container">
                    <div className="row justify-content-center">
                        {isLoading ? <Loader type="ball-scale-multiple"/> : <div className="col-md-5">
                            {deliveries.map((item, index) => {
                                return <DeliveryItem key={index} delivery={{item: item, index: index, showCTA: true}}/>
                            })}
                        </div>}
                    </div>
                </div>
            </div>
        </>
    );
};


export default DeliveryHistory;
